import apiClient from './apiClient';

const audioService = {
    renderAudio: (generationId, scriptIndex, kind) =>
        apiClient.post(`/audio/render`, {
            generation_id: generationId,
            script_index: scriptIndex,
            kind
        }, { responseType: 'blob' }),
};

export default audioService;
